import { Creative, CreativeFolder } from '@/views/creatives/interfaces';
import { PLAY_PRODUCT, CANVAS_PRODUCT } from './productsList';
import { SCENES, HOTSPOTSCENES, SETTINGS, SETTINGSLS } from './creativePlayDetails';
import { DATA_BLANK, DATA_BASIC, DATA_BACKGROUND, DATA_DEMO } from './creativeCanvasDetails';

export const CREATIVE_BASE: Creative = {
  id: 'cre_ko2BK1',
  name: 'My Creative',
  description: 'My Description',
  coverImageS3Url: 'https://s3.amazonaws.com/staging-elasticbeanstalk-environment-databucket-m72zlculvu3v/1637687504791-1637687504791.tmp',
  isTemplate: false,
  type: CANVAS_PRODUCT,
  creativeId: 'webBjUFhNe',
  status: 'draft',
  isArchived: false,
  archivedAt: null,
  deletedAt: null,
  createdAt: '2022-02-07T12:00:00.000Z',
  updatedAt: '2022-02-07T12:00:00.000Z',
  groups: [],
  folderId: 'null',
};

const MOCKSTATICDATA = {
  frames: [
    {
      id: 'F_LXPwZ',
      type: 'Image',
      name: 'My Images',
      locked: [],
    },
  ],
  instances: {
    F_LXPwZ: [
      {
        id: 'I_LXPwZ',
        name: 'My Image',
        visible: true,
        assetId: 'A_ko2BK',
        locked: [],
      },
    ],

  },
  iterations: {
    F_LXPwZ: [
      {
        id: 'I_LXPwZ',
        name: 'My Image',
        visible: true,
        assetId: 'A_ko2BK',
        locked: [],
      },
    ],

  },
  variations: {},
};

export const CREATIVE_PLAY = {
  ...CREATIVE_BASE,
  creativeId: 'webBjUFhNe',
  name: 'Play Creative',
  id: 'f_ko2BK',
  type: PLAY_PRODUCT,
  scenes: SCENES,
  settings: SETTINGS,
  coverImageS3Url: 'https://www.craftsmanplus.com/test/platform/3/interactive.png',
};
export const CREATIVE_STATIC = {
  ...CREATIVE_BASE,
  creativeId: 'webBjUFNRA',
  name: '😁 Static Creative 1F',
  id: 'f_koNRA',
  type: CANVAS_PRODUCT,
  scenes: SCENES,
  data: DATA_BASIC,
};

export const CREATIVE_PLAY_HOTSPOT = {
  ...CREATIVE_BASE,
  creativeId: 'webBjUFHOT',
  name: 'Play Creative with Hotspots',
  id: 'VWeMcSPHU51',
  type: PLAY_PRODUCT,
  scenes: HOTSPOTSCENES,
  settings: SETTINGSLS,
};

export const CREATIVE_STATIC_TEST = {
  ...CREATIVE_BASE,
  creativeId: 'webBjUSTAT',
  name: '😁😁 Static Creative 2F',
  id: 'VWeMcSPHU52',
  type: CANVAS_PRODUCT,
  scenes: HOTSPOTSCENES,
  data: MOCKSTATICDATA,
};

export const CREATIVE_PLAY_NEW: Creative = {
  ...CREATIVE_BASE,
  name: 'Play Creative Blank',
  id: 'webBjUFhNa',
  type: PLAY_PRODUCT,
  scenes: [],
  settings: SETTINGS,
  coverImageS3Url: '',
};

export const CREATIVE_BASE_FOLDER: CreativeFolder = {
  id: 'fol_ko2BK1',
  name: 'My folder',
  parentId: 'null',
  companyId: '123',
  createdAt: '2022-04-28T17:54:15.000Z',
  updatedAt: '2022-04-28T17:54:15.000Z',
};

export const CREATIVE_BASE_FOLDER2: CreativeFolder = {
  id: 'fol_ko2BK2',
  name: 'My new folder',
  parentId: 'null',
  companyId: '123',
  createdAt: '2022-04-20T17:54:15.000Z',
  updatedAt: '2022-04-20T17:54:15.000Z',
};

export const CREATIVE_FOLDER_ITEM: Creative = {
  ...CREATIVE_BASE,
  id: 'cre_fol_ko2BK1',
  name: 'Folder Creative',
  folderId: 'fol_ko2BK1',
  createdAt: '2022-04-28T17:54:15.000Z',
  updatedAt: '2022-04-28T17:54:15.000Z',
};

export const CREATIVE_FOLDER_ITEM_2: Creative = {
  ...CREATIVE_BASE,
  id: 'cre_fol_ko2BK2',
  name: 'Another Folder Creative',
  folderId: 'fol_ko2BK1',
  createdAt: '2022-04-28T17:54:15.000Z',
  updatedAt: '2022-04-28T17:54:15.000Z',
};

export const INTERNAL_FOLDER_ITEM: CreativeFolder = {
  id: 'fol_0_fol_ko2BK1',
  name: 'Internal Folder',
  parentId: 'fol_ko2BK1',
  companyId: '123',
  createdAt: '2022-04-28T17:54:15.000Z',
  updatedAt: '2022-04-28T17:54:15.000Z',
};

export const INTERNAL_FOLDER_ITEM_DEPTH_1: CreativeFolder = {
  id: 'fol_1_fol_ko2BK1',
  name: 'Internal Folder 1',
  parentId: 'fol_0_fol_ko2BK1',
  companyId: '123',
  createdAt: '2022-04-28T17:54:15.000Z',
  updatedAt: '2022-04-28T17:54:15.000Z',
};

export const INTERNAL_FOLDER_ITEM_DEPTH_2: CreativeFolder = {
  id: 'fol_2_fol_ko2BK1',
  name: 'Internal Folder 2',
  parentId: 'fol_1_fol_ko2BK1',
  companyId: '123',
  createdAt: '2022-04-28T17:54:15.000Z',
  updatedAt: '2022-04-28T17:54:15.000Z',
};

export const INTERNAL_FOLDER_ITEM_DEPTH_3: CreativeFolder = {
  id: 'fol_3_fol_ko2BK1',
  name: 'Internal Folder 3',
  parentId: 'fol_2_fol_ko2BK1',
  companyId: '123',
  createdAt: '2022-04-28T17:54:15.000Z',
  updatedAt: '2022-04-28T17:54:15.000Z',
};

export const CREATIVE_CANVAS_BLANK = {
  ...CREATIVE_BASE,
  creativeId: 'webBjUFhNe',
  name: 'Canvas Creative',
  id: 'C_jcuQb',
  type: CANVAS_PRODUCT,
  data: DATA_BLANK,
  settings: {
    boardsToBeExported: [],
    variantBoardIdsToExclude: {},
    namingConvention: '{{Size Dimensions}}_{{Ad Name}}_{{Variant Name}}_{{Export Date}}',
  },
};

export const CREATIVE_CANVAS_NEW: Creative = {
  ...CREATIVE_CANVAS_BLANK,
  name: 'Canvas Creative Blank',
  id: 'webBjUFWoW',
  type: CANVAS_PRODUCT,
  settings: {
    boardsToBeExported: [],
    namingConvention: '',
    variantBoardIdsToExclude: {},
  },
};

export const CREATIVE_CANVAS_BACKGROUND = {
  ...CREATIVE_BASE,
  creativeId: 'webBjUFhNe',
  name: 'Canvas Creative',
  id: 'C_jcuQ1',
  type: CANVAS_PRODUCT,
  boards: [],
  settings: {
    boardsToBeExported: [],
    variantBoardIdsToExclude: {},
    namingConvention: '{{Size Dimensions}}_{{Ad Name}}_{{Variant Name}}_{{Export Date}}',
  },
  data: DATA_BACKGROUND,
};

export const CREATIVE_CANVAS_POPULATED = {
  ...CREATIVE_BASE,
  creativeId: 'mwxacwajvu',
  name: 'Populated Canvas Creative',
  id: 'C_kBn3a',
  type: CANVAS_PRODUCT,
  data: DATA_DEMO,
  settings: {
    boardsToBeExported: [],
    variantBoardIdsToExclude: {},
    namingConvention: '{{Size Dimensions}}_{{Ad Name}}_{{Variant Name}}_{{Export Date}}',
  },
};

export default CREATIVE_PLAY;
